export class ChannelCategory {
  id: string;
  name: string;
  href: string;
  icons: Icon[];
  selected?: boolean;
}

export interface Icon {
  height: number;
  url: string;
  width: number;
}
